import { render } from "./Session-player-page.vue?vue&type=template&id=55dad4d0"
import script from "./Session-player-page.vue?vue&type=script&lang=js"
export * from "./Session-player-page.vue?vue&type=script&lang=js"

import "./Session-player-page.vue?vue&type=style&index=0&id=55dad4d0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__